import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getPreguntasConfirmacionService,
  getPreguntaConfirmacionByIdService,
  updatePreguntaConfirmacionService,
  togglePreguntaConfirmacionActiveService,
} from "../../../services/preguntasConfirmacion/preguntasConfirmacion.service";

export const getPreguntasConfirmacionThunk = createAsyncThunk(
  "preguntasConfirmacion/getAll",
  async ({ page = 1, search = "" } = {}, { rejectWithValue }) => {
    try {
      return await getPreguntasConfirmacionService(page, search);
    } catch (error) {
      if (error.response?.status === 404) {
        return rejectWithValue("Página no válida");
      }
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener preguntas";

      return rejectWithValue(message);
    }
  },
);

export const getPreguntaConfirmacionByIdThunk = createAsyncThunk(
  "preguntasConfirmacion/getById",
  async (id, { rejectWithValue }) => {
    try {
      return await getPreguntaConfirmacionByIdService(id);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al obtener pregunta";

      return rejectWithValue(message);
    }
  },
);

export const updatePreguntaConfirmacionThunk = createAsyncThunk(
  "preguntasConfirmacion/update",
  async ({ id, payload }, { rejectWithValue }) => {
    try {
      return await updatePreguntaConfirmacionService(id, payload);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al actualizar pregunta";

      return rejectWithValue(message);
    }
  },
);

export const togglePreguntaConfirmacionActiveThunk = createAsyncThunk(
  "preguntasConfirmacion/toggleActive",
  async (id, { rejectWithValue }) => {
    try {
      return await togglePreguntaConfirmacionActiveService(id);
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.message ||
        "Error al cambiar estado";

      return rejectWithValue(message);
    }
  },
);
